import React from "react";
import { IconAlertTriangle } from "@tabler/icons-react";

/**
 * Simple confirmation component that displays an unsaved changes warning.
 * Designed to be mounted into EditDialog with type "unsavedChangesConfirmation".
 *
 * This component doesn't manage any state - it just displays the warning message.
 * The actual confirmation logic is handled by the EditDialog's submit/cancel buttons.
 */
const UnsavedChangesConfirmation = () => {
	return (
		<div>
			<div
				style={{
					borderRadius: 5,
					backgroundColor: "var(--lw-gold)",
					display: "flex",
					alignItems: "center",
					color: "black",
					marginBottom: 16,
				}}
			>
				<IconAlertTriangle
					style={{
						color: "black",
						margin: 10,
					}}
				/>
				Warning: You have unsaved changes
			</div>

			<div style={{ marginBottom: 16 }}>
				Are you sure you want to leave this page? Any unsaved changes
				will be lost.
			</div>
		</div>
	);
};

export default UnsavedChangesConfirmation;
